import Drawer from '@mui/material/Drawer';
import React from 'react';
import {SupportSlotDefinitionModel} from '../../../../model/support/slot/support-slot-definition.model';
import {useSupportSlotDefinitionPreviewDrawerState} from '../state/support-slot-definition-preview-drawer-state';
import {SupportSlotDefinitionPreviewCustomersTab} from './SupportSlotDefinitionPreviewCustomersTab';
import {SupportSlotDefinitionPreviewDetailsTab} from './SupportSlotDefinitionPreviewDetailsTab';
import {
  Tabs,
  Tab,
  Box,
  Typography,
} from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

type Props = {
  isDrawerOpen: boolean
  onDrawerClosed: () => void
  initialSlotDefinition: SupportSlotDefinitionModel
  refreshSlotDefinitions: () => Promise<void>
}

const days = ["Poniedziałek", "Wtorek", "Środa", "Czwartek", "Piątek", "Sobota", "Niedziela"];

export const SupportSlotDefinitionPreviewDrawer = ({initialSlotDefinition, refreshSlotDefinitions, isDrawerOpen, onDrawerClosed}: Props) => {
  const state = useSupportSlotDefinitionPreviewDrawerState(initialSlotDefinition)

  return <Drawer
    anchor="right"
    open={isDrawerOpen}
    onClose={onDrawerClosed}
    PaperProps={{
      sx: {
        width: 480,
        marginTop: '34px',
        height: `calc(100%)`,
        position: 'fixed',
        right: 0,
        padding: 3,
        overflowY: 'auto',
      }
    }}
  >
    <Box
      sx={{
        mb: 3,
        mt: 1,
        pb: 1,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1, mt: 1 }}>
        <CalendarTodayIcon fontSize="small" color="action" />
        <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
          {days[state.detailsTabState.slotDefinition?.weekday - 1]} {state.detailsTabState.slotDefinition?.startTime?.substring(0, 5)} - {state.detailsTabState.slotDefinition?.endTime?.substring(0, 5)}
        </Typography>
      </Box>
      <Tabs
        value={state.currentTab}
        onChange={(_, val) => state.setCurrentTab(val)}
        textColor="primary"
        indicatorColor="primary"
        variant="fullWidth"
      >
        <Tab label="Szczegóły" />
        <Tab label="Klienci" />
      </Tabs>
    </Box>

    {state.currentTab === 0 && (
      <Box sx={{ mt: 2 }}>
        <SupportSlotDefinitionPreviewDetailsTab
          state={state.detailsTabState}
          onDrawerClosed={onDrawerClosed}
          refreshSlotDefinitions={refreshSlotDefinitions}
        />
      </Box>
    )}

    {state.currentTab === 1 && (
      <Box sx={{ mt: 2 }}>
        <SupportSlotDefinitionPreviewCustomersTab
          state={state.customersTabState}
        />
      </Box>
    )}
  </Drawer>
}
